import { useCallback } from 'react';
import dayjs from 'dayjs';
import { useContextValue } from '../../Context';
import { CART_HOLD_MINUTES } from './useAdd';

/** Restarts the cart timer, keeping the selections. */
export function useExtend() {
  const { setState } = useContextValue();

  return useCallback(() => {
    setState((prevState) => {
      if (!prevState.currentSelections) return prevState;
      const currentSelections = {
        ...prevState.currentSelections,
        validTo: dayjs().add(CART_HOLD_MINUTES, 'minutes').toDate(),
      };
      localStorage.setItem(
        'currentSelections',
        JSON.stringify(currentSelections)
      );
      return { ...prevState, currentSelections };
    });
  }, [setState]);
}
